const attachment = () =>
  import(
    /* webpackChunkName: "attachment" */ "@/components/AccountPage/Kyc/AutoKyc/InternationalCard/Attachment/index"
  );

export default {
  name: "upload-card",
  components: { attachment },
  data() {
    return {
      frontImgUrl: null,
      backImgUrl: null
    };
  },
  methods: {
    uploadFront(data) {
      this.$emit("onUploadFront", data);
    },
    uploadBack(data) {
      this.$emit("onUploadBack", data);
    }
  }
};
